const id_ID = {
    homepage_title: 'Unduh CalendarTask versi mobile dengan QR code',
    homepage_slogn: 'CalendarTask versi mobile',
    homepage_ios_download: 'App Store dalam tinjauan...',
    homepage_download: 'Unduh',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Unduh CalendarTask versi mobile dengan QR code',
    phonedownload_slogan: 'Sinkron dengan PC & tablet, catat di mana saja',
    phonedownload_send_vip: 'Instal aplikasi dan dapatkan keanggotaan VIP',
    phonedownload_screenshot: 'Screenshot',
    phodedownload_macos: 'CalendarTask versi macOS',
    phodedownload_windows: 'CalendarTask versi Windows',
    phodedownload_otherbutton: 'Lihat sekarang',
    phodedownload_about: 'Hubungi kami',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Tanpa iklan',
    feature_easy: 'Tampilan bulanan, sederhana dan mudah',
    feature_reminder: 'Pengingat kustom',
    feature_countdown: 'Hitung mundur hari jadi',

    vip_task_succ: 'Berhasil. Unduh app mobile untuk aktifkan VIP',
    vip_task_error: 'Penerimaan gagal',

    group_slogn: 'Undangan CalendarTask tim',

    tt_title: 'CalendarTask',
    tt_share_1: 'Dibagikan dengan Anda',
    tt_share_2: 'Jadwal',
    tt_share_show_1: 'Pindai QR code dengan app "CalendarTask", PC dan ponsel akan menampilkan',
    tt_share_show_2: 'jadwal',
    tt_share_scan_1: 'Pindai dengan',
    tt_share_scan_2: 'app "CalendarTask"',
    tt_share_succ: 'Sinkronisasi berhasil',

    v2_copyright: 'Hubungi service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Hak cipta dilindungi.',
    v2_download_appstore: 'Unduh di App Store',
    v2_download_googleplay: 'Tersedia di Google Play',

    v2_main_title: 'CalendarTask Mobile',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobile',
    v2_main_description: 'Cari <span class="name">CalendarTask</span> di App Store atau Google Play',
    v2_download_ios: 'Unduh iOS',
    v2_download_android: 'Unduh Android',
    v2_download_harmonyos: 'Unduh HarmonyOS',
    v2_sync_status: 'Sinkronisasi selesai! 1 diunggah, 0 diunduh',
    v2_feature_title: 'Sinkronisasi data multi-perangkat',
    v2_feature_description: 'Sinkron antar ponsel, tablet dan PC'
};
export default id_ID;
